import { where } from 'firebase/firestore';

// Los usuarios auto-registrados por la app móvil (registeredViaApp: true) se
// gestionan aparte, en la sección exclusiva de super admin — nunca deben
// aparecer en las vistas normales de Usuarios.
export function excludeSelfRegisteredUsersFilter() {
  return where('registeredViaApp', '==', false);
}

// Los usuarios inactivos (isEnabled: false) no deben poder seleccionarse en
// vistas donde se les asigna algo nuevo (p. ej. miembros de una audiencia) —
// una cuenta deshabilitada no debería seguir recibiendo contenido.
export function excludeInactiveUsersFilter() {
  return where('isEnabled', '==', true);
}
